import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import Template from './template';
import {FeatureInfo} from 'components';
import {apiGetServiceFeature} from 'api/ZimssaAPI';
import {useApiRequest} from 'hooks';
import {PAGE_SERVICE_FAMILYMOVE, PAGE_SERVICE_SMALLMOVE, PAGE_SERVICE_MOVECLEANING} from 'commons/ZimssaString';
import {SERVICE_FEATURE} from 'router/PageUrl';

function ServiceFeatureInfoView(): React.ReactElement {
    const history = useHistory();
    const {serviceType, serviceIdx, searchType} = useParams<{ serviceType: string, serviceIdx: string, searchType: string }>();
    const [fetchResult, fetchServiceFeature] = useApiRequest<any>(apiGetServiceFeature);
    const [serviceFeatureInfo, setServiceFeatureInfo] = useState<any>({totalCount: 0, list: []});

    useEffect(() => {
        const {result, data} = fetchResult;

        if (result === 'success' && data) {
            const responseData: {
                isSubmittedOffer: boolean;
                offers: Array<{
                    category: string;
                    id: number;
                    offerImage: string;
                    offerMasterId: number;
                    partnerServiceId: number;
                    status: 'AVAILABLE' | 'NEGOTIABLE' | 'NOT_AVAILABLE';
                    title: string;
                }>
            } = data;

            const partnerServiceOfferModelList = responseData.offers;
            const totalCount = partnerServiceOfferModelList.filter((item) => item.status !== 'NOT_AVAILABLE').length;

            setServiceFeatureInfo({
                totalCount, 
                list: Array.from(new Set(partnerServiceOfferModelList.map((item) => item.category)))
                        .map((item) => ({
                          category: item,
                          sort: Math.max(...partnerServiceOfferModelList.filter((res) => res.category === item).map((res) => res.offerMasterId)),
                        }))
                        .sort((x, y) => x.sort - y.sort)
                        .map((category) => ({
                            category: category.category,
                            titles: partnerServiceOfferModelList
                        .filter((item) => item.category === category.category)
                        .map((title) => ({
                            name: title.title,
                            status: title.status,
                            image: title.offerImage,
                        })),
                    }))
                });
        }
    }, [fetchResult]);

    useEffect(() => {
        if (serviceType && serviceIdx && searchType) {
            fetchServiceFeature({
                type: 'REQUEST',
                body: [serviceType, serviceIdx, searchType],
            });
        }
    }, [fetchServiceFeature, serviceType, serviceIdx, searchType]);

    const props = {
        searchTypes: [
            {
                name: '전체',
                isActive: (() => {
                    if (searchType) {
                        if (searchType === 'all') {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                })(),
                onClick: () => {
                    history.replace(`${SERVICE_FEATURE.url}/${serviceType}/${serviceIdx}/all`);
                },
            },
            {
                name: '기본서비스',
                isActive: searchType === 'available',
                onClick: () => {
                    history.replace(`${SERVICE_FEATURE.url}/${serviceType}/${serviceIdx}/available`);
                },
            },
            {
                name: '협의서비스',
                isActive: searchType === 'negotiable',
                onClick: () => {
                    history.replace(`${SERVICE_FEATURE.url}/${serviceType}/${serviceIdx}/negotiable`);
                },
            },
        ],
        serviceFeature: serviceFeatureInfo,
    };

    const setTitleByServiceType = (serviceType: string) => {
        switch(serviceType) {
            case 'movecleaning':
                return PAGE_SERVICE_MOVECLEANING;
            case 'familymove':
                return PAGE_SERVICE_FAMILYMOVE;
            case 'smallmove':
            default:
                return PAGE_SERVICE_SMALLMOVE;
        }
    }

    return (
        <Template title={setTitleByServiceType(serviceType)} serviceType={serviceType} serviceIdx={serviceIdx ? Number(serviceIdx) : 0}>
            <FeatureInfo {...props} />
        </Template>
    );
}

export default ServiceFeatureInfoView;
